import { derived, writable } from "svelte/store";
export const prices = writable([]);
export const modal = writable(null);
export const modalOptions = writable({});
export const etotal = derived(prices, $prices => $prices.reduce((c, p) => {
    c += p.totalValueOffer;
    return c;
}, 0), 0);
export const modalClose = writable(false);
